import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import {
    default as SmtpAccountInformation,
    SmtpAccountInformationProps,
} from './SmtpAccountInformation';

const styles = require('./OutgoingServerInformation.scss');

export interface OutgoingServerInformationProps {
    isBasicAuth: boolean;
    outgoingServer?: string;
    outgoingPort: string;
    onUpdateOutgoingServer: (value: string) => void;
    onUpdateOutgoingPort: (value: string) => void;
    isRemoteSend: () => boolean;
    isSendOnly: () => boolean;
    smtpAccountInformationProps: SmtpAccountInformationProps;
}

@observer
export default class OutgoingServerInformation extends React.Component<
    OutgoingServerInformationProps,
    {}
> {
    render() {
        return (
            this.props.isRemoteSend() && (
                <div>
                    <TextField
                        className={styles.textbox}
                        label={strings.options_connected_edit_smtpServerTextField}
                        onChanged={this.props.onUpdateOutgoingServer}
                        value={this.props.outgoingServer}
                    />
                    <TextField
                        className={styles.textbox}
                        label={strings.options_connected_edit_smtpPortTextField}
                        onChanged={this.props.onUpdateOutgoingPort}
                        value={this.props.outgoingPort}
                    />
                    {!this.props.isSendOnly() && this.props.isBasicAuth && (
                        <SmtpAccountInformation {...this.props.smtpAccountInformationProps} />
                    )}
                </div>
            )
        );
    }
}
